import { TileLayer, BitmapLayer, ColumnLayer, GeoJsonLayer, COORDINATE_SYSTEM } from 'deck.gl';
import chroma from "chroma-js";


const colorScale = chroma.scale(['24126c', '1fff4f', 'd4ff50' , "orange", "red"]).domain([0, 100]);

export function renderLayers({data}) {
 

  const layer = new ColumnLayer({
    id: 'column-layer',
    data,
    diskResolution: 6,
    radius: 15000,
    angle:90,
    extruded: true,
    pickable: true,
    elevationScale: 5000,
    getPosition: d => [d.column1, d.column2],
    getFillColor: d => {
      if (d.column3 > 0) return colorScale(d.column3).rgb()
      return [60, 60, 60,0]
    },
    getLineColor: d => colorScale(d.column3).rgb(),
    getElevation: d => d.column3,
    onClick: d => console.log(d.object),
  });
  

  return [ layer];
}
